import { createContext, useContext, useEffect, useState } from "react";
import { LanguageContext } from "./LanguageContext";
import { strapiRequest } from "../functions/axiosRequest";

export const FilterContext=createContext();

export function FilterProvider(props){

	const locale=useContext(LanguageContext);
    //console.log(locale)

    const [categories, setCategories]=useState();
    const [category, setCategory]=useState(null);
    const [bioRational, setBioRational]=useState(false);
    const [isSelection, setIsSelection]=useState(true);

    //Fetch product categories
    useEffect(()=>{
        strapiRequest({
            method: 'get',
            endpoint: 'product-categories',
            params: {
                locale: locale.lang.code,
                populate: 'icon'
            }
        }).then((response)=>{
            setCategories(response.data);
        }).catch((error)=>{
            console.log(error);
        });
    },[locale]);

    return(
        <FilterContext.Provider 
            value={{ 
                categories,
                category,
                setCategory,
                bioRational,
                setBioRational,
                isSelection,
                setIsSelection
            }}
        >
            {categories?
                props.children
            :
                null
            }
        </FilterContext.Provider>
    );
};
